import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

export const findAllBrandInsight = async () => {
	try {
		const { data } = await ApiClient.GET('brandInsightList');
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findAllCategories = async () => {
	try {
		const { data } = await ApiClient.GET('findTrendCategories');
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findBrandInsightSummary = async (queryParams) => {
	try {
		const { data } = await ApiClient.GET('brandInsightSummary', queryParams, false);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findBrandInsightSummaryByCategoryAndMarket = async (queryParams) => {
	try {
		const { data } = await ApiClient.GET('brandInsightSummaryByCategoryAndMarket', queryParams, false);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findTrendResearchUserPreference = async () => {
	try {
		const { data } = await ApiClient.GET('findTrendUserPreference');
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const saveTrendResearchUserPreference = async (requestBody) => {
	try {
		const { data } = await ApiClient.POST('saveTrendUserPreference', requestBody);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const updateTrendResearchUserPreference = async (requestBody) => {
	try {
		const { data } = await ApiClient.PUT('updateTrendUserPreference', requestBody);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const findBrandInsight = async (apiSegment, queryParams = '') => {
	try {
		const { data } = await ApiClient.GET('brandInsight', `/${apiSegment + queryParams}`);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const findTrendInsight = async (apiSegment, queryParams = '') => {
	try {
		const { data } = await ApiClient.GET('trendInsight', `/${apiSegment + queryParams}`);
		return data;
	} catch (e) {
		printApiError(e);
	}
};

export const findFabricSummary = async (queryParams) => {
	try {
		const { data } = await ApiClient.GET('fabricSummary', queryParams);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findTrendResearchProductsBySource = async (source, queryParams) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/trend-research/${source}/products`,
			queryParams,
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findTrendMoodBoards = async (queryParams) => {
	try {
		const { data } = await ApiClient.GET('trendMoodBoard', queryParams);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};
export const findMyTrendMoodBoards = async (queryParams) => {
	try {
		const { data } = await ApiClient.GET('myTrendMoodBoard', queryParams);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const getAllProducts = async (queryParams) => {
	try {
		const { data } = await ApiClient.GET('trendProducts', queryParams, false);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const addTrendBoard = async (postData) => {
	try {
		const { data } = await ApiClient.POST('addTrendMoodBoard', postData);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findThemeInsight = async (apiSegment, queryParams = '') => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/trend-research/${apiSegment}`, queryParams, true);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};
export const updateTrendBoardById = async (id, postData) => {
	try {
		const { data } = await ApiClient.PUT('trendMoodBoard', postData, `/${id}`);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const addSectionById = async (id, postData) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/trend-mood-board/${id}/add-section`,
			postData,
			'',
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const addTrendBoardTag = async (moodBoardId, postData) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/trend-mood-board/${moodBoardId}/tags/add`,
			postData,
			'',
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const deleteTrendBoardTag = async (moodBoardId, tagId) => {
	try {
		const { data } = await ApiClient.DELETE(
			`${BASE_URL}/trend-mood-board/${moodBoardId}/tags/${tagId}`,
			'',
			'',
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findAllInstagramInfluencer = async () => {
	try {
		const { data } = await ApiClient.GET('instagramInfluencerList');
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const saveImageSearchHistory = async (postData) => {
	try {
		const { data } = await ApiClient.POST('imageSearchHistory', postData);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findAllImageSearchHistory = async (params) => {
	try {
		const { data } = await ApiClient.GET('imageSearchHistory', params);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findAllImageSearchResult = async (postData, params) => {
	try {
		const { data } = await ApiClient.POST('imageSearch', postData, params);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};
export const findTrendResearchColor = async (source, queryParams) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/trend-research/${source}/colors`,
			queryParams,
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};
export const findTrendResearchGraphics = async (source, queryParams) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/trend-research/${source}/graphics-contents`,
			queryParams,
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findColorGraphicsSummary = async (source, queryParams) => {
	try {
		const { data } = await ApiClient.GET(
			`${BASE_URL}/trend-research/${source}/color-graphics-summary`,
			queryParams,
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const findTrendResearchUserPreferenceColor = async (queryParams) => {
	try {
		const { data } = await ApiClient.GET('findTrendUserPreference', queryParams);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const saveProductToMoodboard = async (postData, id) => {
	try {
		const { data } = await ApiClient.POST(
			`${BASE_URL}/trend-mood-board/${id}/add-product`,
			postData,
			'',
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const removeProductFromMoodBoard = async (productId) => {
	try {
		const { data } = await ApiClient.DELETE('trendMoodBoardProducts', '', `/${productId}`);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const getSingleProduct = async (source, id) => {
	try {
		const { data } = await ApiClient.GET(`${BASE_URL}/trend-research/${source}/products/${id}`, '', true);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const updateProductById = async (source, id, postData) => {
	try {
		const { data } = await ApiClient.PUT(
			`${BASE_URL}/trend-research/${source}/products/${id}`,
			postData,
			'',
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const downloadMoodBoardFile = async (id) => {
	try {
		const data = await ApiClient.GET_FILE_DATA(
			`${BASE_URL}/trend-mood-board/${id}/products/download`,
			'',
			true
		);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};

export const setMyMoodBoard = async (postData) => {
	try {
		const { data } = await ApiClient.POST('setMyMoodBoard', postData);
		return data;
	} catch (e) {
		throw new Error(e);
	}
};
